/**
 * Timer object enhancing setTimeout with start, pause, resume features *
 */
class Timer {
  private timerID?: number
  private start?: number
  private remaining: number
  private callback: (...args: unknown[]) => unknown

  constructor(callback: (...args: unknown[]) => unknown, delay: number) {
    this.remaining = delay
    this.callback = callback
  }

  pause = () => {
    if (this.start) {
      window.clearTimeout(this.timerID)
      this.remaining -= Date.now() - this.start
    }
  }

  run = () => {
    this.start = Date.now()
    if (this.timerID) window.clearTimeout(this.timerID)
    this.timerID = window.setTimeout(this.callback, this.remaining)
  }
}

export default Timer
